import {REFRESH_APP} from 'constants/ActionTypes';

export const showRefreshAppAlert = () => {
  return {
    type: REFRESH_APP
  };
};
